import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "role-capability-card"
};
const _hoisted_2 = {
  key: 0,
  class: "path-desc"
};
const _hoisted_3 = {
  class: "skilled-box"
};
const _hoisted_4 = {
  key: 0,
  class: "skilled-path"
};
const _hoisted_5 = {
  key: 0,
  class: "separator"
};
const _hoisted_6 = {
  key: 1,
  class: "over-limit-box"
};
const _hoisted_7 = {
  class: "over-limit-path"
};
const _hoisted_8 = {
  key: 1
};
const _hoisted_9 = {
  class: "increase-box"
};
const _hoisted_10 = {
  class: "increase-capability-item"
};
const _hoisted_11 = {
  class: "opera-capability-item"
};
const _hoisted_12 = {
  key: 2,
  class: "opera-capability-item"
};
const _hoisted_13 = ["innerHTML"];
const _hoisted_14 = {
  class: "dialog-footer"
};
import { ref, computed } from 'vue';
import { ElButton, ElMessage, ElRow } from 'element-plus';
import { request } from '@/manager/net_manager';
import { getCapability, isAdminType, isUserType } from '@/tools/utils';
import store from '@/store';
export default {
  __name: 'RoleCapabilityCard',
  props: {
    roleId: {
      type: [String, Number],
      required: true
    },
    data: {
      type: Object,
      required: true
    }
  },
  emits: ['update', 'edit'],

  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit; // refs

    const message = ref(null);
    const confirmationDialog = ref(false);
    const confirmationTitle = ref('');
    const confirmationTips = ref('');
    const confirmationContinue = ref(true);
    const increaseValue = ref(0); // computed

    const userType = computed(() => store.state.user ? parseInt(store.state.user.user_type) : 4);
    const capabilityData = computed(() => {
      return getCapability(props.data.capability_id);
    });
    const assignablePoint = computed(() => {
      return store.state.role_info[props.roleId]?.capability_point ?? 0;
    });
    const increaseEnable = computed(() => {
      if (assignablePoint.value <= 0) return false;
      if (props.data.extraordinary) return false;
      return props.data.max_value > props.data.probability;
    });
    const increaseMaxValue = computed(() => {
      const maxValue = props.data['max_value'] - props.data['probability'];
      return Math.min(maxValue, assignablePoint.value);
    });

    const enhanceCapability = () => {
      if (message.value) {
        message.value.close();
      }

      if (increaseValue.value === 0) {
        message.value = ElMessage.error({
          message: '未选择成长数值',
          duration: 1500
        });
        return;
      }

      request('capabilities/role_capabilities/increase/', {
        'role_capability_id': props.data['id'],
        'increase_value': increaseValue.value
      }, 'POST').then(response => {
        if (response.code !== 0) {
          message.value = ElMessage.error({
            message: response.msg,
            duration: 1500
          });
          return;
        }

        store.commit('update_role_info', {
          role_id: props.roleId,
          key: 'capability_point',
          value: assignablePoint.value - increaseValue.value
        });
        emits('update');
        increaseValue.value = 0;
        message.value = ElMessage.success({
          message: '分配完成',
          duration: 1500
        });
      });
    };

    const editCapability = () => {
      emits('edit', props.data);
    };

    return (_ctx, _cache) => {
      const _component_el_slider = _resolveComponent("el-slider");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [__props.data.highlight ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [__props.data['skilled_path'] ? (_openBlock(), _createElementBlock("text", _hoisted_4, " 专精途径：" + _toDisplayString(__props.data['skilled_path']), 1)) : _createCommentVNode("", true)]), __props.data['over_limit_path'] ? (_openBlock(), _createElementBlock("text", _hoisted_5, " /")) : _createCommentVNode("", true), __props.data['over_limit_path'] ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("text", _hoisted_7, " 超限途径：" + _toDisplayString(__props.data['over_limit_path']), 1)])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _createVNode(_unref(ElRow), null, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(capabilityData.value['explain']), 1)]),
        _: 1
      }), _unref(isUserType)(userType.value) && increaseEnable.value ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createVNode(_component_el_slider, {
        modelValue: increaseValue.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => increaseValue.value = $event),
        min: 0,
        max: increaseMaxValue.value
      }, null, 8, ["modelValue", "max"])])]), _createElementVNode("div", _hoisted_11, [_createVNode(_unref(ElButton), {
        class: "enhanceCapability",
        disabled: increaseValue.value === 0,
        onClick: enhanceCapability
      }, {
        default: _withCtx(() => [_createTextVNode(" 能力点分配（" + _toDisplayString(increaseValue.value === 0 ? assignablePoint.value : `${assignablePoint.value} - ${increaseValue.value}`) + "） ", 1)]),
        _: 1
      }, 8, ["disabled"])])])) : _createCommentVNode("", true), _unref(isAdminType)(userType.value) ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createVNode(_unref(ElButton), {
        class: "edit-capability",
        onClick: editCapability
      }, {
        default: _withCtx(() => [...(_cache[4] || (_cache[4] = [_createTextVNode(" 能力调整 ", -1)]))]),
        _: 1
      })])) : _createCommentVNode("", true), _createVNode(_component_el_dialog, {
        modelValue: confirmationDialog.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => confirmationDialog.value = $event),
        title: confirmationTitle.value,
        width: "800"
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_14, [confirmationContinue.value ? (_openBlock(), _createBlock(_unref(ElButton), {
          key: 0,
          onClick: _cache[1] || (_cache[1] = $event => {
            confirmationDialog.value = false;

            _ctx.removeCapability($event, true);
          })
        }, {
          default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createTextVNode(" 确认 ", -1)]))]),
          _: 1
        })) : _createCommentVNode("", true), _createVNode(_unref(ElButton), {
          class: "cancel",
          onClick: _cache[2] || (_cache[2] = $event => confirmationDialog.value = false)
        }, {
          default: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createTextVNode("取消", -1)]))]),
          _: 1
        })])]),
        default: _withCtx(() => [_createElementVNode("text", {
          innerHTML: confirmationTips.value
        }, null, 8, _hoisted_13)]),
        _: 1
      }, 8, ["modelValue", "title"])]);
    };
  }

};